<!-- components/LeaveConfirmationModal.vue -->
<template>
    <div v-if="show" class="modal-backdrop">
      <div class="modal-content">
        <h5 class="mb-1">Unsaved Changes</h5>
        <p>You have unsaved changes. Do you really want to leave?</p>
        <button @click="$emit('confirm')" class="btn btn-danger my-2">Leave</button>
        <button @click="$emit('cancel')" class="btn btn-secondary">Cancel</button>
      </div>
    </div>
  </template>
  
  <script setup>
  defineProps({
    show: Boolean
  });
  defineEmits(['confirm', 'cancel']);
  </script>
  
  <style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 0.5rem;
  min-width: 300px;
  max-width: 400px;
}
  </style>
  